import React, { useCallback } from 'react';
import { MTable } from '@Components/Base';
import { Contact, ContactListProps } from '../types';
import ContactActionColumn from '../components/ContactActionColumn';
import ContactNoData from '../components/ContactNoData';
import { createContactListColumns } from './ContactListColumns';

const ContactListDesktop: React.FC<ContactListProps> = ({
  dataSource,
  totalItems,
  pageSize,
  currentPage,
  onChangePage,
  onSort,
  isLoading = false,
  onView,
  onEdit,
  isSearchApplied = false,
  isFiltersApplied = false,
}) => {
  const renderActionColumn = useCallback(
    (_text: string, record: unknown) => (
      <ContactActionColumn
        contact={record as Contact}
        onView={onView}
        onEdit={onEdit}
      />
    ),
    [onView, onEdit]
  );

  const columns = createContactListColumns(renderActionColumn);

  if (!isLoading && (!dataSource || dataSource.length === 0)) {
    return (
      <ContactNoData
        isSearchApplied={isSearchApplied}
        isFiltersApplied={isFiltersApplied}
      />
    );
  }

  return (
    <MTable
      columns={columns}
      dataSource={dataSource}
      totalItems={totalItems}
      pageSize={pageSize}
      currentPage={currentPage}
      onChangePage={onChangePage}
      onSort={onSort}
      loading={isLoading}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default ContactListDesktop;
